require('../../modules/es6.reflect.has');
module.exports = require('../../modules/_core').Reflect.has;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/reflect/has.js
// module id = njv6
// module chunks = 63